export interface ICheckItemState {
	active: boolean
	itemId: number
	itemName: string
}

export enum ECheckItemActionTypes {
	SHOW_CHECK_ITEM = 'SHOW_CHECK_ITEM',
	CLOSE_CHECK_ITEM = 'CLOSE_CHECK_ITEM',
}

export interface IShowCheckItemAction {
	type: ECheckItemActionTypes.SHOW_CHECK_ITEM
	payload: { id: number; name: string }
}

export interface ICloseCheckItemAction {
	type: ECheckItemActionTypes.CLOSE_CHECK_ITEM
}

export type CheckItemAction = IShowCheckItemAction | ICloseCheckItemAction
